/* Per-section schema definitions for the public CMS.
 * Drives the labelled forms in ContentEditor.
 */

// field kind: text | textarea | image | stat-list | string-list

export const SECTION_SCHEMAS = {
    hero: {
        label: "Hero · Page d'accueil",
        description:
            "Bandeau principal de la page d'accueil — visible dès l'arrivée des visiteurs.",
        fields: [
            { key: "badge", kind: "text", label: "Badge (au-dessus du titre)" },
            { key: "title", kind: "text", label: "Titre principal — partie sobre" },
            { key: "titleEmphasis", kind: "text", label: "Titre principal — partie dorée" },
            { key: "subtitle", kind: "textarea", label: "Sous-titre", rows: 4 },
            { key: "cta1", kind: "text", label: "Bouton principal — texte" },
            { key: "cta2", kind: "text", label: "Bouton secondaire — texte" },
        ],
    },
    stats: {
        label: "Chiffres-clés",
        description:
            "Statistiques affichées sur la page d'accueil (3 blocs).",
        fields: [
            { key: "kicker", kind: "text", label: "Kicker (petite ligne au-dessus)" },
            {
                key: "items",
                kind: "stat-list",
                label: "Statistiques (valeur · suffixe · label)",
                max: 4,
            },
        ],
    },
    manifesto: {
        label: "Manifeste",
        description:
            "Bloc manifeste éditorial — quelques lignes courtes signées.",
        fields: [
            { key: "kicker", kind: "text", label: "Kicker" },
            { key: "line1", kind: "text", label: "Ligne 1" },
            { key: "line2", kind: "text", label: "Ligne 2" },
            { key: "line3", kind: "text", label: "Ligne 3" },
        ],
    },
    about_founder: {
        label: "Le fondateur",
        description:
            "Bloc « À propos du fondateur » — affiché sur les pages publiques.",
        fields: [
            { key: "kicker", kind: "text", label: "Kicker" },
            { key: "title", kind: "text", label: "Nom" },
            { key: "role", kind: "text", label: "Rôle / titre" },
            { key: "photo", kind: "image", label: "Photo du fondateur" },
            { key: "intro", kind: "textarea", label: "Pitch (1-3 lignes)", rows: 4 },
        ],
    },
    cities: {
        label: "Villes / Géographies",
        description:
            "Liste des villes affichées en pied de page et page Contact.",
        fields: [
            { key: "list", kind: "string-list", label: "Villes" },
        ],
    },
    contact: {
        label: "Contact",
        description: "Coordonnées et message d'introduction du formulaire de contact.",
        fields: [
            { key: "email", kind: "text", label: "Email de contact" },
            { key: "kicker", kind: "text", label: "Kicker" },
            { key: "intro", kind: "textarea", label: "Message d'introduction", rows: 4 },
        ],
    },
    footer: {
        label: "Pied de page",
        description: "Tagline et signature affichés en pied de page.",
        fields: [
            { key: "tagline", kind: "textarea", label: "Tagline (texte long)", rows: 3 },
            { key: "signature", kind: "text", label: "Signature" },
        ],
    },
};
